<template>
  <div class="p-4">
    <div class="loader-overlay" v-if="isDataFetch">
      <b-spinner
        style="width: 3rem; height: 3rem"
        type="grow"
        class="text-white"
      ></b-spinner>
    </div>
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-6 text-left">
            <h4>Quote list</h4>
          </div>
          <div class="col-6 text-right">
            <button class="btn btn-sm btn-primary" @click="fnGoNewQuote()">
              New
            </button>
          </div>
        </div>
      </div>

      <div class="card-body">
        <div class="search-row mb-3">
          <div class="form-group search-box item mb-0">
            <label for="paginate" class="mb-0">Search</label>
            <input
              v-model="q"
              type="search"
              class="form-control"
              placeholder="Search ..."
              @keyup.enter="fnSearch()"
            />
          </div>
          <div class="status-box item">
            <label for="paginate" class="mb-0">BDM</label>
            <select
              v-model="selectedBDM"
              class="form-control sits_select"
              @change="fnSearch()"
            >
              <option value="">All BDM</option>
              <option
                v-for="item in getBDMTeamMember"
                :key="item.id"
                :value="item.id"
              >
                {{ item.name }}
              </option>
            </select>
          </div>

          <div class="status-box item">
            <label for="paginate" class="mb-0">Status</label>
            <select
              v-model="selectedStatus"
              class="form-control sits_select"
              @change="fnSearch()"
            >
              <option value="">All Status</option>
              <option
                v-for="item in optionStatus"
                :key="item.value"
                :value="item.value"
              >
                {{ item.text }}
              </option>
            </select>
          </div>
          <div class="item">
            <button class="btn btn-sm btn-primary mt-4" @click="fnSearch()">
              Search
            </button>
          </div>
          <div class="item">
            <button class="btn btn-sm btn-primary mt-4" @click="fnClear()">
              Clear
            </button>
          </div>
        </div>

        <div class="table-responsive table-sm">
          <table
            class="
              v-datatable-light
              table table-bordered table-hover table-striped table-center
            "
          >
            <thead>
              <tr>
                <th class="header-item"></th>
                <th class="header-item">
                  <a
                    href="javascript:void(0)"
                    @click.prevent="fnChangeSort('id')"
                    >Quote Id</a
                  >
                  <span v-if="sort_direction == 'desc' && sort_field == 'id'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'id'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item">Source</th>
                <th class="header-item">Dealer</th>
                <th class="header-item">Dealer user</th>
                <th class="header-item">
                  <a href="javascript:void(0)">Client name</a>
                </th>
                <th class="header-item">
                  <a
                    href="javascript:void(0)"
                    @click.prevent="fnChangeSort('settlementDate')"
                    >Submitted date</a
                  >
                  <span
                    v-if="
                      sort_direction == 'desc' && sort_field == 'settlementDate'
                    "
                    >&uarr;</span
                  >
                  <span
                    v-if="
                      sort_direction == 'asc' && sort_field == 'settlementDate'
                    "
                    >&darr;</span
                  >
                </th>

                <th class="header-item">
                  <a
                    href="javascript:void(0)"
                    @click.prevent="fnChangeSort('edd')"
                    >Est. Delivery Date</a
                  >
                  <span v-if="sort_direction == 'desc' && sort_field == 'edd'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'edd'"
                    >&darr;</span
                  >
                </th>

                <th class="header-item">
                  <a
                    href="javascript:void(0)"
                    @click.prevent="fnChangeSort('settlementDate')"
                    >Settlement date</a
                  >
                  <span
                    v-if="
                      sort_direction == 'desc' && sort_field == 'settlementDate'
                    "
                    >&uarr;</span
                  >
                  <span
                    v-if="
                      sort_direction == 'asc' && sort_field == 'settlementDate'
                    "
                    >&darr;</span
                  >
                </th>
                <th class="header-item v-th-center">
                  <a
                    href="javascript:void(0)"
                    @click.prevent="fnChangeSort('sortOrder')"
                    >Status</a
                  >
                  <span
                    v-if="sort_direction == 'desc' && sort_field == 'sortOrder'"
                    >&uarr;</span
                  >
                  <span
                    v-if="sort_direction == 'asc' && sort_field == 'sortOrder'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item v-th-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(quote, index) in getQuotePaginateData.data">
                <tr :key="(quote, index)">
                  <td
                    @click="toggle(index)"
                    :class="{ opened: opened.includes(index) }"
                  >
                    <span class="text-info pl-2"
                      ><i class="fas fa-outdent"></i
                    ></span>
                  </td>

                  <td>{{ quote.id }}</td>
                  <td>
                    {{ quote.quoteSource }}
                  </td>
                  <td>
                    {{ quote.dealer }}
                  </td>
                  <td>
                    {{ quote.dealer_user }} {{ quote.dealer_user_last_name }}
                  </td>
                  <td class="column-2">
                    <span
                      >{{ quote.client }} |
                      <span class="text-black-60 fs-600">
                        {{ quote.hAddressState }}</span
                      ></span
                    >
                    <br />
                    <span class="text-black-60 fs-600">{{
                      quote.employerName
                    }}</span>
                  </td>
                  <td>{{ quote.firstSubmittedDate }}</td>
                  <td>
                    {{ quote.edd | dateConvertDDMMYYYY }}
                  </td>
                  <td>
                    {{ quote.settlementDate | dateConvertDDMMYYYY }}
                  </td>
                  <td class="v-td-center">
                    <WDQuoteStatusBadge
                      :status="quote.status"
                    ></WDQuoteStatusBadge>
                  </td>
                  <td class="v-td-center">
                    <div class="d-flex">
                      <a
                        @click="fnGoViewQuote(quote.id)"
                        v-b-tooltip.hover
                        title="View quote"
                        class="d-inline pr-2"
                        ><i class="far fa-eye text-primary"></i
                      ></a>
                      <a
                        @click="fnGoEditQuote(quote.id)"
                        v-b-tooltip.hover
                        title="Update quote"
                        class="d-inline pr-2"
                        ><i class="far fa-edit text-primary"></i
                      ></a>
                      <appModalDocumentsUpload
                        :quoteId="quote.id"
                        :quoteType="'quote'"
                      >
                      </appModalDocumentsUpload>

                      <div class="d-inline pr-2">
                        <appModalQuoteTransfer :rowData="quote">
                        </appModalQuoteTransfer>
                      </div>

                      <appModalMsgDealer
                        :quoteId="quote.id"
                        :quote="quote"
                        class="d-inline pr-2"
                      >
                      </appModalMsgDealer>
                    </div>
                  </td>
                </tr>
                <!-- Expandable section -->
                <tr v-if="opened.includes(index)">
                  <td colspan="13">
                    <div class="row mr-2 ml-2">
                      <div class="col-lg-6 col-md-6 col-12">
                        <dl class="row">
                          <dt class="col-sm-5">Vehicle</dt>
                          <dd class="col-sm-7">{{ quote.vehicleInfo }}</dd>
                          <dt class="col-sm-5">Updated</dt>
                          <dd class="col-sm-7">{{ quote.updated_at }}</dd>
                          <dt class="col-sm-5">Finance Application No.</dt>
                          <dd class="col-sm-7">{{ quote.fa_no }}</dd>
                          <dt class="col-sm-5">Financier</dt>
                          <dd class="col-sm-7">{{ quote.financier }}</dd>
                          <dt class="col-sm-5">Pricing Document</dt>
                          <dd class="col-sm-7" v-if="quote.pricingDocumentUrl">
                            <a
                              class="text-primary fw-600"
                              :href="quote.pricingDocumentUrl"
                              target="_blank"
                              >View document</a
                            >
                          </dd>
                        </dl>

                        <!-- List of  application notes-->
                        <dl class="row" v-if="quote && quote.notes">
                          <dt class="col-sm-12">Application Notes</dt>
                          <dd class="col-sm-12">
                            <div>
                              <b-card-text
                                v-html="quote.notes.applicationNotes"
                              ></b-card-text>
                            </div>
                          </dd>
                        </dl>
                      </div>
                      <div class="col-lg-6 col-md-6 col-12">
                        <!-- VSA quotes and leads logs -->
                        <WDVsaQuoteLeadsLogs
                          v-if="quote.vsa_logs.length"
                          :vsaLogs="quote.vsa_logs"
                        ></WDVsaQuoteLeadsLogs>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>

              <tr>
                <td colspan="13">
                  <div class="sits-pagination-row">
                    <div class="items-per-page">
                      <div class="pr-2">
                        <p class="mb-0">Items per page</p>
                      </div>
                      <div class="pr-5">
                        <select
                          v-model="recordsPerPage"
                          class="form-control sits_select"
                          @change="fnRecordsPerPage(recordsPerPage)"
                        >
                          <option value="10">10</option>
                          <option value="15">15</option>
                          <option value="20">20</option>
                          <option value="30">30</option>
                          <option value="40">40</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>

                    <div>
                      <pagination
                        :limit="5"
                        :data="getQuotePaginateData"
                        @pagination-change-page="fnGetQuoteList"
                      ></pagination>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pagination from 'laravel-vue-pagination'
import * as messageService from '../../../services/message.service'
import * as quoteService from '../../../services/quote.service'
import * as authService from '../../../services/auth.service'
import * as taxTableService from '../../../services/taxTable.service'
import { mapGetters, mapActions } from 'vuex'
import { optionStatus } from '../../../services/data.service'
import appModalDocumentsUpload from '../../../components/quote/ModalDocumentsUpload.vue'
import appModalMsgDealer from '../../../components/quote/ModalMsgDealer.vue'
import WDQuoteStatusBadge from '../../../components/wd/WDQuoteStatusBadge.vue'
import WDVsaQuoteLeadsLogs from '../../../components/wd/WDVsaQuoteLeadsLogs.vue'
import appModalQuoteTransfer from '../../../components/admin/ModalQuoteTransfer.vue'

export default {
  name: 'dealerQuoteList',
  components: {
    pagination,
    appModalDocumentsUpload,
    appModalMsgDealer,
    WDQuoteStatusBadge,
    WDVsaQuoteLeadsLogs,
    appModalQuoteTransfer
  },
  data() {
    return {
      isDataFetch: true,
      optionStatus: optionStatus,
      opened: [],
      quoteCalculation: {},
      loginUserObj: {},
      selectedBDM: '',
      page: 1,
      recordsPerPage: 15,
      q: '',
      selectedStatus: '',
      sort_direction: 'asc',
      sort_field: 'sortOrder',

      paginate: {
        selectedBDM: '',
        page: 1,
        recordsPerPage: 15,
        q: '',
        selectedStatus: '',
        sort_direction: 'asc',
        sort_field: 'sortOrder'
      }
    }
  },
  computed: {
    ...mapGetters([
      'getQuoteSingle',
      'getQuotePaginateData',
      'getQuotePaginate',
      'getUserById'
    ]),
    getBDMTeamMember() {
      return this.getUserById.bdm_users ?? []
    }
  },

  methods: {
    ...mapActions(['fetchQuoteSingle', 'fetchQuotePaginate', 'fetchUserById']),
    toggle(id) {
      const index = this.opened.indexOf(id)
      if (index > -1) {
        this.opened.splice(index, 1)
      } else {
        this.opened.push(id)
      }
    },
    fnGoNewQuote() {
      this.$router.push({ name: 'bdm.quoteNew' })
    },
    fnGoViewQuote(id) {
      this.$router.push({ name: 'bdm.quoteView', params: { quoteId: id } })
    },
    fnGoEditQuote(id) {
      this.$router.push({ name: 'bdm.quoteEdit', params: { quoteId: id } })
    },

    fnQuoteStatusUpdate: async function (quoteId, statusId) {
      let obj = {
        status: statusId
      }

      try {
        await quoteService.updateQuoteStatus(quoteId, JSON.stringify(obj))
      } catch (error) {
        messageService.fnSweetAlertErrorToast(
          'Quote status - update',
          'Something wrong on quote status update'
        )
      }
    },

    fnGetQuoteList: async function (page = 1) {
      let obj1 = this.paginate
      let obj2 = {
        selectedBDM: this.selectedBDM,
        page: page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchQuotePaginate(objNew)
    },
    fnRecordsPerPage() {
      let obj1 = this.paginate
      let obj2 = {
        selectedBDM: this.selectedBDM,
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }

      this.fetchQuotePaginate(objNew)
    },
    fnSearch() {
      let obj1 = this.paginate
      let obj2 = {
        selectedBDM: this.selectedBDM,
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchQuotePaginate(objNew)
    },
    fnChangeSort(field) {
      if (this.sort_field == field) {
        this.sort_direction = this.sort_direction == 'asc' ? 'desc' : 'asc'
      } else {
        this.sort_field = field
      }
      let obj1 = this.paginate
      let obj2 = {
        selectedBDM: this.selectedBDM,
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchQuotePaginate(objNew)
    },

    fnClear() {
      this.q = ''
      this.selectedStatus = ''

      let obj1 = this.paginate
      let obj2 = {
        selectedBDM: this.selectedBDM,
        page: 1,
        recordsPerPage: 15,
        q: '',
        selectedStatus: '',
        sort_direction: 'asc',
        sort_field: 'sortOrder'
      }

      let objNew = { ...obj1, ...obj2 }

      this.fetchQuotePaginate(objNew)
    }
  },
  created() {
    this.loginUserObj = authService.getUserFromToken()
    this.userId = this.loginUserObj.id
    this.fetchUserById(this.userId)

    // Store taxTable information in local storage
    taxTableService.storeTaxTable()
  },

  async mounted() {
    this.isDataFetch = true
    let obj1 = this.paginate
    let obj2 = {
      selectedBDM: this.selectedBDM,
      page: 1,
      recordsPerPage: 15,
      q: '',
      selectedStatus: '',
      sort_direction: 'asc',
      sort_field: 'sortOrder'
    }

    let objNew = { ...obj1, ...obj2 }

    await this.fetchQuotePaginate(objNew)
    this.isDataFetch = false
  }
}
</script>

<style lang="scss" scoped>
.search-row {
  display: flex;
  // justify-content: space-between;
  gap: 20px;
  .search-box {
    width: 450px;
  }
  .status-box {
    width: 250px;
  }

  .item {
    align-self: center;
  }
}

.sits-pagination-row {
  display: flex;
  gap: 10px;
  align-items: baseline;
  padding-top: 5px;
  padding-bottom: 5px;

  .items-per-page {
    display: flex;
    align-items: baseline;
  }

  ul.pagination {
    margin-bottom: 0;
  }

  .page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: red;
    border-color: red;
  }
}
</style>
